export const NEWLY_JOINED_USERS_LOAD = 'NEWLY_JOINED_USERS_LOAD'
export const NEWLY_JOINED_USERS_LOAD_FULFILLED = 'NEWLY_JOINED_USERS_LOAD_FULFILLED'
export const NEWLY_JOINED_USERS_LOAD_REJECTED = 'NEWLY_JOINED_USERS_LOAD_REJECTED'
